// extracted by mini-css-extract-plugin
export default {"CustomerListItemContainer":"style_CustomerListItemContainer__ChxJ2","namePhoneContainer":"style_namePhoneContainer__O63yg"};